angular.module("firmatarioRiscattoTermine.components", []).component("firmatarioRiscattoTermine", {
    templateUrl: "ng/components/riscattoTermine/firmatarioRiscattoTermine/firmatarioRiscattoTermine.view.html",
    bindings: {
        richiestePostVendita: "<",
        validateFirmatario: "&",
        changedSignature: "<",
        hideCf: '<'
    },
    controllerAs: "firmatarioRiscattoTermineCtrl",
    controller: function FirmatarioRiscattoTermine(
        $RichiestePostVenditaService,
        $arcService,
        $modalService,
        Pf,
        $timeout,
        $rootScope,
        $istatService,
        $configService,
        $portalService,
        $q
    ) {
        var self = this;

        self.$onInit = function () {
            self.validateFirmatario({
                validity: false
            });
            self.mapInfo = "";
            self.$rootScope = $rootScope;
            self.mapComuni = $rootScope.comuniMap;
            self.mapComuniNsilSoppressi = $rootScope.mapComuniSoppressi;
            self.nationsList = $rootScope.nazioniEstere.filter(
                function (elem) {
                    return elem.name != "ITALIA";
                }
            );
            self.supportModel = {
                restIsPending: false,
                datiFirmatario: Pf.build(),
                searchStarted: false,
                newFirmatario: false,
                datiIncompleti: false,
                enableModal: false,
                signerIsCorrect: true
            }

            retrieveStepInfo();
            self.legaleRappresentante = self.richiestePostVendita.metadata.riscattoATermine &&
                self.richiestePostVendita.metadata.riscattoATermine.signers &&
                self.richiestePostVendita.metadata.riscattoATermine.signers[$configService.getUser().identifier];
            if (!self.legaleRappresentante || (self.legaleRappresentante && !self.legaleRappresentante.cf)) {
                $rootScope.$broadcast("componentLoader", {
                    action: "OPEN"
                })
                self.searchFirmatario();
            } else {
                var comuni = self.mapComuni.concat(self.mapComuniNsilSoppressi);
                self.supportModel.datiFirmatario = Pf.build(self.legaleRappresentante).setDefaultPfValues(self.nationsList, comuni);
                self.supportModel.restIsPending = false;
                self.supportModel.newFirmatario = true
                self.validateComponent();
            }

            self.isAru = $portalService.isAru() ? true : false
        }

        self.$onChanges = function (changed) {
            if (changed.changedSignature && typeof changed.changedSignature.currentValue != 'undefined') {
                self.validateComponent();
            }
        }

        self.check = function (el) {
            el.selected = !el.selected;
            self.validateComponent();
        }

        var getStati = function () {
            $istatService.getNazioni()
                .then(function (response) {
                    self.nationsList = response.domainList;

                    self.nationsList = self.nationsList.filter(
                        function (elem) {
                            return elem.name != "ITALIA";
                        }
                    );
                })
        };

        var retrieveStepInfo = function () {
            $RichiestePostVenditaService
                .getStepInfo(self.richiestePostVendita.id, self.richiestePostVendita.viewIndex)
                .then(function (response) {
                    if (response.success) {
                        self.mapInfo = response.message;
                        self.enabledLoader = false;
                    }
                })
                .catch(function (error) {
                    console.log(error);
                    self.enabledLoader = false;
                });
        }

        self.searchFirmatario = function () {
            self.supportModel.restIsPending = true;
            self.supportModel.searchStarted = true;
            if (self.supportModel.datiFirmatario && self.supportModel.datiFirmatario.cf) {
                rimuoviFirmatario().then(function (response) {
                    $arcService
                        .getSignerPv(self.supportModel.cfFirmatario, self.richiestePostVendita.id)
                        .then(function (response) {
                            self.supportModel.restIsPending = false;
                            var comuni = self.mapComuni.concat(self.mapComuniNsilSoppressi);
                            if (response && response.metadata && response.metadata.riUserF) {
                                response.metadata.riUserF.firmatario.selected = true
                                self.supportModel.datiFirmatario = Pf.build(response.metadata.riUserF).setDefaultPfValues(self.nationsList, comuni);
                            } else if (response && response.metadata && response.metadata.riUserG) {
                                var addInfoFirmatario = {
                                    firmatario: {
                                        selected: true
                                    }
                                }
                                Object.assign(response.metadata.riUserG, addInfoFirmatario)
                                self.supportModel.datiFirmatario = Pf.build(response.metadata.riUserG).setDefaultPfValues(self.nationsList, comuni);
                            } else {
                                self.supportModel.datiFirmatario = Pf.build({
                                    cf: self.supportModel.cfFirmatario,
                                    firmatario: {
                                        selected: true
                                    }
                                }).setDefaultPfValues(self.nationsList, comuni);
                            }
                            self.supportModel.cfFirmatario = null;
                            self.validateComponent();
                            $rootScope.$broadcast("componentLoader", {
                                action: "CLOSE"
                            })
                            self.supportModel.newFirmatario = true;
                        })
                        .catch(function (error) {
                            console.log(error);
                            self.supportModel.restIsPending = false;
                            $rootScope.$broadcast("componentLoader", {
                                action: "CLOSE"
                            })
                        })

                }).catch(function (error) {
                    console.log(error);
                    self.supportModel.restIsPending = false;
                    $rootScope.$broadcast("componentLoader", {
                        action: "CLOSE"
                    })
                })
            } else {
                $arcService
                    .getSignerPv(self.supportModel.cfFirmatario, self.richiestePostVendita.id)
                    .then(function (response) {
                        self.supportModel.restIsPending = false;
                        var comuni = self.mapComuni.concat(self.mapComuniNsilSoppressi);
                        if (response && response.metadata && response.metadata.riUserF) {
                            response.metadata.riUserF.firmatario.selected = true
                            self.supportModel.datiFirmatario = Pf.build(response.metadata.riUserF).setDefaultPfValues(self.nationsList, comuni);
                        } else if (response && response.metadata && response.metadata.riUserG) {
                            var addInfoFirmatario = {
                                firmatario: {
                                    selected: true
                                }
                            }
                            Object.assign(response.metadata.riUserG, addInfoFirmatario)
                            self.supportModel.datiFirmatario = Pf.build(response.metadata.riUserG).setDefaultPfValues(self.nationsList, comuni);
                        } else {
                            self.supportModel.datiFirmatario = Pf.build({
                                cf: self.supportModel.cfFirmatario,
                                firmatario: {
                                    selected: true
                                }
                            }).setDefaultPfValues(self.nationsList, comuni);
                        }
                        self.supportModel.cfFirmatario = null;
                        self.validateComponent();
                        $rootScope.$broadcast("componentLoader", {
                            action: "CLOSE"
                        })
                        self.supportModel.newFirmatario = true;
                    })
                    .catch(function (error) {
                        console.log(error);
                        self.supportModel.restIsPending = false;
                        $rootScope.$broadcast("componentLoader", {
                            action: "CLOSE"
                        })
                    })

            }

        }

        self.addRemoveFirmatario = function () {
            self.validateFirmatario({
                validity: false
            });
            $arcService.deleteSubjectSelection(self.supportModel.datiFirmatario.cf, self.richiestePostVendita.id)
                .then(function (response) {
                    if (response.success) {
                        self.richiestePostVendita.metadata.riscattoATermine.signers[$configService.getUser().identifier] = {}
                        self.supportModel.datiFirmatario = {}
                    }
                    self.validateComponent();
                    self.supportModel.newFirmatario = false;

                })
                .catch(function (error) {
                    console.log(error)
                    self.validateComponent();
                })
        }


        self.editFirmatario = function () {
            var comuni = self.mapComuni.concat(self.mapComuniNsilSoppressi);
            self.supportModel.datiFirmatario = Pf.build(self.supportModel.datiFirmatario).setDefaultPfValues(self.nationsList, comuni)
            $timeout(function () {
                $modalService.openModal('editFirmatario');
            }, 100)
            self.supportModel.enableModal = true;
        }

        self.closeFirmatarioModal = function (pf, fromBackButton) {
            if (pf) {
                self.supportModel.datiFirmatario = pf;
            }
            $modalService.closeModal('editFirmatario');
            self.supportModel.enableModal = false;
            if (fromBackButton) {
                self.validateComponent();
            } else {
                self.validateComponent(true);
            }
            console.log(pf)
        }

        self.validateComponent = function (buttonPress) {
            if (self.richiestePostVendita.metadata.riscattoATermine.firmaDigitale && !self.richiestePostVendita.metadata.riscattoATermine.firmaDigitaleEsterna && !self.supportModel.datiFirmatario.email && !self.supportModel.datiFirmatario.telefono) {
                self.supportModel.datiFirmatario.isOk = false;
                self.validateFirmatario({
                    validity: false
                });

            } else {
                self.supportModel.datiFirmatario.isOk = validatePf(self.supportModel.datiFirmatario)
                if (self.supportModel.datiFirmatario.isOk) {
                    self.richiestePostVendita.metadata.riscattoATermine.signers[$configService.getUser().identifier] = self.supportModel.datiFirmatario;
                    self.validateFirmatario({
                        validity: true,
                        buttonPress: buttonPress
                    });
                } else {
                    self.validateFirmatario({
                        validity: false
                    });
                }
            }
        }

        var validatePf = function (pf) {
            if (pf && pf.editModeMinimal) {
                return (
                    !!pf.firmatario &&
                    !!pf.firmatario.ruolo
                )
            } else {
                if (pf && pf.isEstero) {
                    return (
                        !!pf.nome &&
                        !!pf.cognome &&
                        !!pf.sesso &&
                        !!pf.documento &&
                        !!pf.documento.dataRilascio &&
                        !!pf.documento.dataScadenza &&
                        !!pf.documento.enteRilascio.name &&
                        !!pf.documento.numero &&
                        !!pf.documento.provincia &&
                        !!pf.documento.tipo &&
                        (!!pf.documento.statoEsteso || !!pf.documento.statoEsteso.name) &&
                        !!pf.datiNascita.stato.value &&
                        !!pf.datiNascita.data &&
                        !!pf.datiNascita.provincia &&
                        !!pf.residenza.cap &&
                        (!!pf.residenza.statoEsteso || !!pf.residenza.statoEsteso.name) &&
                        !!pf.residenza.numeroCivico &&
                        !!pf.residenza.provincia &&
                        !!pf.residenza.indirizzo &&
                        !!pf.titolare &&
                        pf.documentiCaricati
                    )
                } else if (pf && !pf.isEstero && pf.cf && pf.cf.substr(11, 1).toUpperCase() == 'Z') {
                    return (
                        !!pf.cf &&
                        !!pf.nome &&
                        !!pf.cognome &&
                        !!pf.sesso &&
                        !!pf.documento &&
                        !!pf.documento.dataRilascio &&
                        !!pf.documento.dataScadenza &&
                        !!pf.documento.enteRilascio.name &&
                        !!pf.documento.numero &&
                        !!pf.documento.provincia &&
                        !!pf.documento.tipo &&
                        (!!pf.documento.luogo || !!pf.documento.luogoEsteso.nome) &&
                        !!pf.datiNascita.stato.value &&
                        !!pf.datiNascita.data &&
                        !!pf.datiNascita.provincia &&
                        !!pf.residenza.cap &&
                        (!!pf.residenza.comune || !!pf.residenza.luogoEsteso.nome) &&
                        !!pf.residenza.numeroCivico &&
                        !!pf.residenza.provincia &&
                        !!pf.residenza.indirizzo &&
                        !!pf.titolare &&
                        pf.documentiCaricati
                    )
                } else if (pf && pf.cf) {
                    return (
                        !!pf.cf &&
                        !!pf.nome &&
                        !!pf.cognome &&
                        !!pf.sesso &&
                        !!pf.documento &&
                        !!pf.documento.dataRilascio &&
                        !!pf.documento.dataScadenza &&
                        !!pf.documento.enteRilascio.name &&
                        !!pf.documento.numero &&
                        !!pf.documento.provincia &&
                        !!pf.documento.tipo &&
                        (!!pf.documento.luogo || !!pf.documento.luogoEsteso.nome) &&
                        (!!pf.datiNascita.comune || !!pf.datiNascita.luogoEsteso.nome) &&
                        !!pf.datiNascita.data &&
                        !!pf.datiNascita.provincia &&
                        !!pf.residenza.cap &&
                        (!!pf.residenza.comune || !!pf.residenza.luogoEsteso.nome) &&
                        !!pf.residenza.numeroCivico &&
                        !!pf.residenza.provincia &&
                        !!pf.residenza.indirizzo &&
                        !!pf.titolare &&
                        pf.documentiCaricati
                    )
                }

            }

        }

        var rimuoviFirmatario = function () {

            return $q(function (resolve, reject) {


                self.validateFirmatario({
                    validity: false
                });
                $arcService.deleteSubjectSelection(self.supportModel.datiFirmatario.cf, self.richiestePostVendita.id)
                    .then(function (response) {
                        if (response.success) {
                            self.richiestePostVendita.metadata.riscattoATermine.signers[$configService.getUser().identifier] = {}
                            self.supportModel.datiFirmatario = {}
                            self.supportModel.newFirmatario = false;
                        }
                        self.validateComponent();
                        resolve(true);
                    })
                    .catch(function (error) {
                        console.log(error)
                        self.validateComponent();
                        reject(false);
                    })
            })
        }
    }
})